import React from "react";

export default function ConnectionStatus() {
  const [online, setOnline] = React.useState(() => navigator.onLine !== false);
  React.useEffect(() => {
    const update = () => setOnline(navigator.onLine !== false);
    window.addEventListener("online", update); window.addEventListener("offline", update);
    return () => { window.removeEventListener("online", update); window.removeEventListener("offline", update); };
  }, []);
  return online ? null : <div role="status" className="bg-amber-50 px-4 py-3 text-sm text-amber-950">You're offline. Reconnect to view current order updates or place an order. Nothing is submitted offline.</div>;
}
